<div class="form-field">
  <fieldset [class.disabled]="disabled">
    <div *ngIf="currency" style="display:flex; align-items:end; height:100%">
      <div style="margin-bottom:1px">$</div>
      <input type="number"
             [placeholder]="placeholder"
             [disabled]="disabled"
             [(ngModel)]="value"
             (input)="handleInputChange($event)"
             [required]="required"
             step="0.01"
             [min]="min"
             [max]="max"
             autocomplete="off"
             />
    </div>
    <input *ngIf="!currency" type="number"
           [placeholder]="placeholder"
           [disabled]="disabled"
           [(ngModel)]="value"
           (input)="handleInputChange($event)"
           [required]="required"
           [step]="step"
           [min]="min"
           [max]="max"
           autocomplete="off"/>
    <legend>{{ label }}</legend>
  </fieldset>
</div>
